import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { GetUserRecentEventHistoryProps, UserRecentEventHistoryResult } from "./types";

/**
 * Retrieve recent custom events and purchases for display in the User Search "Event History" tab.
 */
export const getUserRecentEventHistory = reactQueryFetcherAdapter(
  cacheKey,
  (signal, { userId }: GetUserRecentEventHistoryProps): Promise<UserRecentEventHistoryResult> => {
    return fetch(`/apps/user_recent_event_history/${userId}`, "GET", { signal }, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
